import { RESET_FORM } from '../actionTypes';
import { profileSecurityActions } from '../reducer';

export default () => profileSecurityActions[RESET_FORM]();
